import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { cn } from '@makyoapp/makyo-tw-ui'
import { Button } from '@makyoapp/makyo-ui'

import { BrandKitFontModalV2 } from './BrandKitFontModalV2'

interface BrandKitFontV2Props {
  fromSettingField?: boolean
}

export function BrandKitFontV2({ fromSettingField }: BrandKitFontV2Props) {
  const [modal, setModal] = useState('')
  const { t } = useTranslation()

  return (
    <>
      <div className='w-full'>
        {fromSettingField ? (
          <button
            className={cn(
              'text-gray-100 text-xs py-2 px-3 rounded-sm w-full transition-colors bg-tertiary-500 dark:bg-tertiary-500/85 hover:bg-tertiary-600'
            )}
            onClick={() => setModal('show')}
          >
            {t('Edit Global Typography')}
          </button>
        ) : (
          <Button className='w-full' onClick={() => setModal('show')}>
            <Trans>Edit Font Settings</Trans>
          </Button>
        )}
      </div>
      {Boolean(modal) && <BrandKitFontModalV2 show={modal} setShow={setModal} />}
    </>
  )
}
